import { useState } from "react";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { KeyRound, Eye, EyeOff } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [pwd, setPwd] = useState("");
  const [confirm, setConfirm] = useState("");
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (pwd.length < 8) { setError("At least 8 characters"); return; }
    if (pwd !== confirm) { setError("Passwords do not match"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pwd });
      toast.success("Password reset — please login");
      navigate("/login");
    } catch (e2) {
      setError(e2.response?.data?.detail || "Reset failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-white rounded-3xl border border-slate-200 p-8 shadow-sm">
        <div className="w-14 h-14 mx-auto rounded-full bg-teal-100 text-teal-700 flex items-center justify-center"><KeyRound className="w-7 h-7" /></div>
        <h1 className="font-heading text-2xl font-extrabold mt-4 text-slate-900 text-center">Set a new password</h1>
        {!token ? (
          <p className="mt-4 text-center text-rose-600 text-sm">Missing reset token. Please use the link from your email.</p>
        ) : (
          <form onSubmit={submit} className="mt-5 space-y-4">
            <div>
              <Label>New password</Label>
              <div className="relative mt-1">
                <Input data-testid="reset-password" type={show ? "text" : "password"} value={pwd} onChange={(e) => setPwd(e.target.value)} className="pr-10" />
                <button type="button" onClick={() => setShow(!show)} className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400">
                  {show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                </button>
              </div>
            </div>
            <div>
              <Label>Confirm new password</Label>
              <Input data-testid="reset-confirm" type={show ? "text" : "password"} value={confirm} onChange={(e) => setConfirm(e.target.value)} className="mt-1" />
            </div>
            {error && (<div className="rounded-lg bg-rose-50 border border-rose-200 text-rose-700 text-sm px-3 py-2">{error}</div>)}
            <Button data-testid="reset-submit" type="submit" disabled={loading} className="w-full h-11 bg-teal-600 hover:bg-teal-700 text-white rounded-full font-semibold">
              {loading ? "Resetting..." : "Reset password"}
            </Button>
            <p className="text-center text-sm text-slate-600"><Link to="/login" className="font-semibold text-teal-700">Back to login</Link></p>
          </form>
        )}
      </div>
    </div>
  );
}
